"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var util_1 = require("../../utils/util");
var Views = (function (_super) {
    __extends(Views, _super);
    function Views(baseUrl) {
        _super.call(this, baseUrl, "views");
    }
    Views.prototype.getById = function (id) {
        var v = new View(this);
        v.concat("('" + id + "')");
        return v;
    };
    Views.prototype.getByTitle = function (title) {
        return new View(this, "getByTitle('" + title + "')");
    };
    Views.prototype.add = function (title, personalView, additionalSettings) {
        var _this = this;
        if (personalView === void 0) { personalView = false; }
        if (additionalSettings === void 0) { additionalSettings = {}; }
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.View" },
            "Title": title,
            "PersonalView": personalView,
        }, additionalSettings));
        return this.postAs({ body: postBody }).then(function (data) {
            return {
                data: data,
                view: _this.getById(data.Id),
            };
        });
    };
    return Views;
}(queryable_1.QueryableCollection));
exports.Views = Views;
var View = (function (_super) {
    __extends(View, _super);
    function View(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(View.prototype, "fields", {
        get: function () {
            return new ViewFields(this);
        },
        enumerable: true,
        configurable: true
    });
    View.prototype.update = function (properties) {
        var _this = this;
        var postBody = JSON.stringify(util_1.Util.extend({
            "__metadata": { "type": "SP.View" },
        }, properties));
        return this.post({
            body: postBody,
            headers: {
                "X-HTTP-Method": "MERGE",
            },
        }).then(function (data) {
            return {
                data: data,
                view: _this,
            };
        });
    };
    View.prototype.delete = function () {
        return this.post({
            headers: {
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    View.prototype.renderAsHtml = function () {
        var q = new queryable_1.Queryable(this, "renderashtml");
        return q.get();
    };
    return View;
}(queryable_1.QueryableInstance));
exports.View = View;
var ViewFields = (function (_super) {
    __extends(ViewFields, _super);
    function ViewFields(baseUrl, path) {
        if (path === void 0) { path = "viewfields"; }
        _super.call(this, baseUrl, path);
    }
    ViewFields.prototype.getSchemaXml = function () {
        var q = new queryable_1.Queryable(this, "schemaxml");
        return q.get();
    };
    ViewFields.prototype.add = function (fieldTitleOrInternalName) {
        var q = new ViewFields(this, "addviewfield('" + fieldTitleOrInternalName + "')");
        return q.post();
    };
    ViewFields.prototype.move = function (fieldInternalName, index) {
        var q = new ViewFields(this, "moveviewfieldto");
        var postBody = JSON.stringify({ "field": fieldInternalName, "index": index });
        return q.post({ body: postBody });
    };
    ViewFields.prototype.removeAll = function () {
        var q = new ViewFields(this, "removeallviewfields");
        return q.post();
    };
    ViewFields.prototype.remove = function (fieldInternalName) {
        var q = new ViewFields(this, "removeviewfield('" + fieldInternalName + "')");
        return q.post();
    };
    return ViewFields;
}(queryable_1.QueryableCollection));
exports.ViewFields = ViewFields;
